import { Component, computed, inject } from '@angular/core';
import { KENDO_STACKLAYOUT } from '@progress/kendo-angular-layout';
import { PageContainerComponent } from '@unity/layouts/page-container/page-container.component';
import { LayoutService } from '@unity/services/layout.service';
import { SessionService } from '@unity/services/session.service';
import { ActionSharedComponent } from '@unity/shared/composed/action-shared/action-shared.component';
import { QuickActions } from '@unity/utils/quick-actions';

@Component({
  selector: 'unity-view-dashboard-page',
  imports: [PageContainerComponent, KENDO_STACKLAYOUT, ActionSharedComponent],
  templateUrl: './view-dashboard-page.component.html',
  styleUrl: './view-dashboard-page.component.scss',
})
export class ViewDashboardPageComponent {
  private readonly sessionService = inject(SessionService);
  private readonly layoutService = inject(LayoutService);
  protected pageGridLayoutGap = this.layoutService.detailCardGridLayoutGap;

  protected createAgreementAction = QuickActions.CreateAgreement;
  protected viewAgreementsAction = QuickActions.ManageAgreements;
  protected createFormSchemaAction = QuickActions.CreateFormTemplate;
  protected manageFormSchemasAction = QuickActions.ManageFormSchemas;
  protected createProgramAction = QuickActions.CreateProgram;
  protected createVendorAction = QuickActions.CreateVendor;
  protected manageVendorsAction = QuickActions.ManageVendors;
  protected createCommunityAction = QuickActions.CreateCommunity;
  protected manageCommunitiesAction = QuickActions.ManageCommunities;
  protected manageProgramsAction = QuickActions.ManagePrograms;
  protected manageBusinessPartnersAction = QuickActions.ManageBusinessPartners;
  protected createBusinessPartnerAction = QuickActions.CreateBusinessPartner;
  protected createInternalUserAction = QuickActions.CreateInternalUser();
  protected manageUsersAction = QuickActions.ManageUsers;
  protected createUserAction = QuickActions.CreateUser();
  protected listReportsAction = QuickActions.ListReports;
  protected exitImpersonationAction = QuickActions.EndImpersonation(() => this.exitImpersonation());
  protected logoutAction = QuickActions.LogOut(() => this.logout());

  protected readonly $isImpersonating = computed(() => this.sessionService.$isImpersonating());
  private exitImpersonation = () => {
    return this.sessionService.endImpersonation();
  };

  private logout = () => {
    return this.sessionService.logout();
  };
}
